import React from 'react';
import PropTypes from 'prop-types';

import Header from './Header';
import Footer from './Footer';

import LayoutRoutes from './LayoutRoutes';

import styles from './Layout.module.css';

const App = ({ children }) =>
  <div>
    <div className={styles.wrapper}>
      <Header />
      <div className={`container ${styles.container}`}>
        <LayoutRoutes></LayoutRoutes>
      </div>
      <div className={styles.push} />
    </div>
    <Footer />
  </div>;

App.propTypes = {
  children: PropTypes.object,
  location: PropTypes.object,
};

export default App;
